var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPrimaryContact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6192 1.63862C12.9966 0.936575 14.0034 0.936574 14.3808 1.63862L24.3993 20.2765C24.7574 20.9427 24.2749 21.75 23.5185 21.75H3.48151C2.72515 21.75 2.24258 20.9427 2.60069 20.2765L12.6192 1.63862Z",
    fill: "#6D7A8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4954 14.4217C13.0962 14.4217 12.7722 14.0969 12.7722 13.6967V9.42501C12.7722 9.02481 13.0962 8.70001 13.4954 8.70001C13.8946 8.70001 14.2186 9.02481 14.2186 9.42501V13.6967C14.2186 14.0969 13.8946 14.4217 13.4954 14.4217",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5048 17.7305C12.9716 17.7305 12.5357 17.2984 12.5357 16.7638C12.5357 16.2293 12.9629 15.7972 13.4952 15.7972H13.5048C14.0381 15.7972 14.4691 16.2293 14.4691 16.7638C14.4691 17.2984 14.0381 17.7305 13.5048 17.7305",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPrimaryContact);
export default __webpack_public_path__ + "static/media/noPrimaryContact.2d6fac4f8ab9d7c10bb9ed32e558d35f.svg";
export { ForwardRef as ReactComponent };